import Icon, { IconProps } from './Icon';

import CheckDoneIcon from '../../../assets/icons/check-done.svg?react';

const CheckDone: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <CheckDoneIcon />
        </Icon>
    );
};

export default CheckDone;

